import { useEffect, useRef, useState } from "react";
import { useImmer } from "use-immer";
import SimpleReactValidator from "simple-react-validator";
import {
  getTenantTaxingSettingsApi,
  updateTenantTaxingSettingsApi,
} from "../apis/taxingApis";
import { errorMessage, successMessage } from "../../../utils";

export const useTaxingConfig = () => {
  const [, setForceUpdate] = useState(0);
  const [state, setState] = useImmer({
    formData: { tax_term: "", tax_id_term: "" },
    isLoading: true,
    isSubmitting: false,
    hasChanges: false,
  });

  const formValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    }),
  );

  useEffect(() => {
    fetchTaxingSettings();
  }, []);

  const fetchTaxingSettings = async () => {
    try {
      setState((draft) => {
        draft.isLoading = true;
      });

      const response = await getTenantTaxingSettingsApi();
      if (!response?.success) {
        throw new Error(
          response?.message || "Failed to fetch tenant taxing settings",
        );
      }

      setState((draft) => {
        draft.formData = response.data;
      });
    } catch (error) {
      errorMessage(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch tenant taxing settings",
      );
    } finally {
      setState((draft) => {
        draft.isLoading = false;
      });
    }
  };

  const updateTaxingSettings = async () => {
    try {
      setState((draft) => {
        draft.isSubmitting = true;
      });

      const response = await updateTenantTaxingSettingsApi(state.formData);
      if (!response?.success) {
        throw new Error(
          response?.message || "Failed to update tenant taxing settings",
        );
      }

      setState((draft) => {
        draft.formData = response.data;
        draft.hasChanges = false;
      });
      successMessage(response.message);
    } catch (error) {
      errorMessage(
        error.response?.data?.message ||
          error.message ||
          "Failed to update tenant taxing settings",
      );
    } finally {
      setState((draft) => {
        draft.isSubmitting = false;
      });
    }
  };

  const onChange = (event) => {
    const { name, value } = event.target;
    setState((draft) => {
      draft.formData[name] = value;
      draft.hasChanges = true;
    });
  };

  const onSubmit = () => {
    if (formValidator.current.allValid()) {
      updateTaxingSettings();
    } else {
      formValidator.current.showMessages();
      setForceUpdate((previous) => previous + 1);
    }
  };

  return { formValidator, state, onChange, onSubmit };
};
